
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ui/components",
      function () {
        return require("private-next-pages/ui/components.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ui/components"])
      });
    }
  